import { Component, effect, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonExplainModule } from '../../common-explain/common-explain.module';
import { TranslateModule } from '@ngx-translate/core';
import { SortDropdownItem } from '../../common-explain/components/ex-sort-dropdown/ex-sort-dropdown.component';
import { SortDirEnum } from '../../common-explain/models/sort';
import { DbPostSearchSort, SortFieldEnum } from '../../tenders/models/tender-search-body';
import { PublicationSource } from '../search/publication-source';
import { FilterItem } from '../../common-explain/components/filter-text-and-items/filter-text-and-items.component';
import { firstValueFrom } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { ApiService } from '../../shared/services/api/api.service';
import { SearchService } from '../../shared/services/search.service';
import { Topic } from '../../models/topic';
import { SearchMode } from '../search/search-mode';
import { NavigationEnd, Router } from '@angular/router';
import { ArticleImSearchService } from '../../shared/services/article-im-search.service';
import { ExplainMainModuleEnum } from 'src/app/core/user/user.model';

@Component({
  selector: 'app-search-bar',
  imports: [CommonExplainModule, TranslateModule],
  templateUrl: './search-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './search-bar.component.scss',
})
export class SearchBarComponent implements OnInit {
  currentPage = input.required<string>();
  inImpacterView = input(false);
  publicationSource!: PublicationSource;
  topics!: Topic[];
  searchMode: SearchMode = SearchMode.TEXT;
  sortOptions: SortDropdownItem[] = [
    {
      label: 'search.sort-by-publication_date-desc',
      value: 'publication_date',
      direction: SortDirEnum.DESC,
      unidirectional: true,
    },
    {
      label: 'search.sort-by-publication_date-asc',
      value: 'publication_date',
      direction: SortDirEnum.ASC,
      unidirectional: true,
    },
  ];
  defaultSort: DbPostSearchSort = {
    field: SortFieldEnum.PUBLICATION_DATE,
    dir: SortDirEnum.DESC,
  };

  service: SearchService;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private searchService: SearchService,
    private articleImSearchService: ArticleImSearchService
  ) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
      const currentUrl = event['urlAfterRedirects'];
      this.publicationSource = this.getCurrentPublicationSource(currentUrl);
      this.updateSearchMode();
    });
    this.service = searchService;
    effect(() => {
      if (this.inImpacterView()) {
        this.service = this.articleImSearchService;
        this.publicationSource = PublicationSource.ARTICLES;
        this.searchMode = SearchMode.TEXT;
      } else this.service = this.searchService;
    });
  }

  ngOnInit() {
    firstValueFrom(this.apiService.topic.getUserTopics(ExplainMainModuleEnum.TERRITORY_INTEL).pipe(first())).then(topics => {
      this.topics = topics;
    });
  }

  getCurrentPublicationSource(currentUrl: string): PublicationSource {
    if (currentUrl.includes('/article')) {
      return PublicationSource.ARTICLES;
    } else if (currentUrl.includes('/admin-doc')) {
      return PublicationSource.ADMIN_DOCS;
    } else {
      return PublicationSource.OTHERS;
    }
  }

  updateSearchMode() {
    this.service.SearchModeMap.set(PublicationSource.ARTICLES, this.searchMode);
    this.service.SearchModeMap.set(PublicationSource.ADMIN_DOCS, this.searchMode);
  }

  topicSearch(item: FilterItem | null) {
    if (item) {
      this.searchMode = SearchMode.TOPICS;
      this.service.SearchModeMap.set(this.publicationSource, SearchMode.TOPICS);
      this.service.searchValue = item;
      this.service.sentPageIndex(1);
      this.service.sentText(item.id.toString());
    }
  }

  textSearch(text: string | null) {
    if (this.currentPage() === 'impacter') {
      this.service.sentName(text ?? '');
    } else if (text !== null) {
      this.searchMode = SearchMode.TEXT;
      this.service.SearchModeMap.set(this.publicationSource, SearchMode.TEXT);
      this.service.searchValue = text;
      this.service.sentPageIndex(1);
      this.service.sentText(text);
    }
  }

  resetSearch() {
    this.service.SearchModeMap.set(this.publicationSource, SearchMode.TEXT);
    this.service.sentText('');
    this.service.sentName('');
    this.service.searchValue = undefined;
  }

  sortSelect(sort: DbPostSearchSort) {
    this.service.sentSort(sort);
  }
}
